import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import Tooltip from "rc-tooltip";

export const AboutusJoin = () => {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className="aboutus-join-warp">
          <div className="inner">
            <div className="aboutus-join-title">
              <Title title={t("aboutus.join.title")}></Title>
            </div>

            <div className="aboutus-join-bg-img"></div>
            <div className="aboutus-join-box">
              <div className="aboutus-join-box-item">
                <div className="date">2019</div>
                <div className="text">{t("aboutus.join.found")}</div>
              </div>
              <div className="aboutus-join-box-item">
                <div className="date">200+</div>
                <div className="text">{t("aboutus.join.partner")}</div>
              </div>
              <div className="aboutus-join-box-item">
                <div className="date">30,000+</div>
                <div className="text">{t("aboutus.join.connect")}</div>
              </div>
              <div className="aboutus-join-box-item">
                <div className="date">40,000,000+</div>
                <div className="text">{t("aboutus.join.server")}</div>
              </div>
              <div className="aboutus-join-box-item">
                <a className="join-button" href="/joinus">
                  {t("aboutus.join.button")}
                </a>
              </div>
            </div>
            <div className="aboutus-join-position">
              <div className="aboutus-join-position-content">
                <div className="aboutus-join-position-item">
                  <div className="aboutus-join-position-label">
                    {t("aboutus.join.total")}
                  </div>
                  <div className="aboutus-join-position-city">
                    {t("aboutus.join.beijing")}
                  </div>
                  <div className="aboutus-join-position-address">
                    {t("aboutus.join.address")}
                  </div>
                </div>
                <div className="aboutus-join-position-item">
                  <div className="aboutus-join-position-label">
                    {t("aboutus.join.nation")}
                  </div>
                  <div className="aboutus-join-position-city">
                    {t("aboutus.join.citys")}
                  </div>

                  <div className="aboutus-join-position-address">
                    {/* <Tooltip
                      placement="bottom"
                      mouseLeaveDelay={0.001}
                      trigger={["hover"]}
                      overlay={t("common.footer.beijing-company-address")}
                    >
                      <a
                        className="companyAddress"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://map.baidu.com/search/%E5%8C%97%E8%BE%B0%E4%B8%96%E7%BA%AA%E4%B8%AD%E5%BF%83-b%E5%BA%A7/@12957096.065,4838990.38,19z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E8%BE%B0%E4%B8%96%E7%BA%AA%E4%B8%AD%E5%BF%83-b%E5%BA%A7&c=131&src=0&pn=0&sug=0&l=12&b=(12913638.56,4802627.47;13004838.56,4848067.47)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                      >
                        {t("aboutus.join.beijing")}
                      </a>
                    </Tooltip>
                    |
                    <Tooltip
                      placement="bottom"
                      mouseLeaveDelay={0.001}
                      trigger={["hover"]}
                      overlay={t("common.footer.chengdu-company-address")}
                    >
                      <a
                        className="companyAddress"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://map.baidu.com/search/%E5%9B%9B%E5%B7%9D%E7%9C%81%E6%88%90%E9%83%BD%E5%B8%82%E9%AB%98%E6%96%B0%E5%8C%BA%E5%A4%A9%E5%BA%9C%E4%BA%94%E8%A1%97200%E5%8F%B7/@11584949.095,3551926.08,19z?querytype=s&da_src=shareurl&wd=%E5%9B%9B%E5%B7%9D%E7%9C%81%E6%88%90%E9%83%BD%E5%B8%82%E9%AB%98%E6%96%B0%E5%8C%BA%E5%A4%A9%E5%BA%9C%E4%BA%94%E8%A1%97200%E5%8F%B7&c=75&src=0&pn=0&sug=0&l=19&b=(11584592.845,3551748.58;11585305.345,3552103.58)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                      >
                        {t("aboutus.join.chendu")}
                      </a>
                    </Tooltip>
                    |
                    <Tooltip
                      placement="bottom"
                      mouseLeaveDelay={0.001}
                      trigger={["hover"]}
                      overlay={t("common.footer.shanghai-company-address")}
                    >
                      <a
                        className="companyAddress"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%A8%E6%B5%A6%E5%8C%BA%E6%94%BF%E6%B0%91%E8%B7%AF%20300/@13526698.060111606,3650411.68,17.82z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%A8%E6%B5%A6%E5%8C%BA%E6%94%BF%E6%B0%91%E8%B7%AF%20300&c=289&src=0&pn=0&sug=0&l=19&b=(13526042.625,3650077;13526739.625,3650393)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                      >
                        {t("aboutus.join.shanghai")}
                      </a>
                    </Tooltip>
                    |
                    <Tooltip
                      placement="bottom"
                      mouseLeaveDelay={0.001}
                      trigger={["hover"]}
                      overlay={t("common.footer.wuhan-company-address")}
                    >
                      <a
                        className="companyAddress"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://map.baidu.com/search/%E6%AD%A6%E6%B1%89%E5%B8%82%E4%B8%9C%E6%B9%96%E6%96%B0%E6%8A%80%E6%9C%AF%E5%BC%80%E5%8F%91%E5%8C%BA%E5%85%B3%E5%B1%B1%E5%A4%A7%E9%81%93%E4%BF%9D%E5%88%A9%E5%9B%BD%E9%99%85%E4%B8%AD%E5%BF%83%207%20%E6%A5%BC%E6%B0%AA%E7%A9%BA%E9%97%B4/@12738102.301707588,3543590.205,14.78z?querytype=s&da_src=shareurl&wd=%E6%AD%A6%E6%B1%89%E5%B8%82%E4%B8%9C%E6%B9%96%E6%96%B0%E6%8A%80%E6%9C%AF%E5%BC%80%E5%8F%91%E5%8C%BA%E5%85%B3%E5%B1%B1%E5%A4%A7%E9%81%93%E4%BF%9D%E5%88%A9%E5%9B%BD%E9%99%85%E4%B8%AD%E5%BF%83%207%20%E6%A5%BC%E6%B0%AA%E7%A9%BA%E9%97%B4&c=289&src=0&pn=0&sug=0&l=17&b=(13525909.749999998,3650054.2825892856;13527486.370223215,3650769.0774107147)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2"
                      >
                        {t("aboutus.join.wuhan")}
                      </a>
                    </Tooltip>
                    |<span> {t("aboutus.join.shenzhen")}</span> */}
                    <span> {t("aboutus.join.beijing")}</span> ｜
                    <span> {t("aboutus.join.shanghai")}</span> ｜
                    <span> {t("aboutus.join.shenzhen")}</span> ｜
                    <span> {t("aboutus.join.chendu")}</span> ｜
                    <span> {t("aboutus.join.wuhan")}</span>
                  </div>
                </div>
              </div>
              <div className="aboutus-join-position-map">
                <img
                  src="//files.authing.co/authing-website/aboutus-position-map.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
